"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Spinner extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "spinner-wrapper d-flex align-items-center justify-content-center flex-column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "spinner-border m-5",
      role: "status"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, "Loading...")));
  }
}
var _default = exports.default = Spinner;
module.exports = exports.default;